export class CNPJ {
  static tamanhoCNPJSemDV = 12;

  static regexCNPJSemDV = /^([A-Z\d]){12}$/;

  static regexCNPJ = /^([A-Z\d]){12}(\d){2}$/;

  static regexCaracteresMascara = /[./-]/g;

  static BLACKLIST = new Set<string>([
    '00000000000000',
    '11111111111111',
    '22222222222222',
    '33333333333333',
    '44444444444444',
    '55555555555555',
    '66666666666666',
    '77777777777777',
    '88888888888888',
    '99999999999999',
  ])

  static pesosDV = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  static isValid(cnpj: string) {
    const cnpjSemMascara = this.removeMascaraCNPJ(cnpj).toUpperCase();
    if (this.regexCNPJ.test(cnpjSemMascara) && !this.BLACKLIST.has(cnpjSemMascara)) {
      const dvInformado = cnpjSemMascara.substring(this.tamanhoCNPJSemDV);
      const dvCalculado = this.calculaDV(cnpjSemMascara.substring(0, this.tamanhoCNPJSemDV));
      if (dvInformado === undefined) {
        return false;
      }
      return dvInformado === dvCalculado;
    }
    return false;
  }

  static calculaDV(cnpj: string): string | undefined {
    const cnpjSemMascara = this.removeMascaraCNPJ(cnpj).toUpperCase();

    if (this.regexCNPJSemDV.test(cnpjSemMascara) && !this.BLACKLIST.has(cnpjSemMascara)) {
      let somatorioDV1 = 0;
      let somatorioDV2 = 0;

      for (let i = 0; i < this.tamanhoCNPJSemDV; i += 1) {
        const asciiDigito = cnpjSemMascara.charCodeAt(i) - 48; // regra oficial
        somatorioDV1 += asciiDigito * this.pesosDV[i + 1];
        somatorioDV2 += asciiDigito * this.pesosDV[i];
      }

      const dv1 = somatorioDV1 % 11 < 2 ? 0 : 11 - (somatorioDV1 % 11);
      somatorioDV2 += dv1 * this.pesosDV[this.tamanhoCNPJSemDV];
      const dv2 = somatorioDV2 % 11 < 2 ? 0 : 11 - (somatorioDV2 % 11);

      return `${dv1}${dv2}`;
    }

    // Não é possível calcular o DV pois o CNPJ fornecido é inválido
    return undefined;
  }

  static removeMascaraCNPJ(cnpj: string) {
    return cnpj.replace(this.regexCaracteresMascara, '');
  }
}
